import { FREE_URL } from "../../lib/checkoutLinks";

export const StickyMobileCTA = () => (
  <div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0A0A0B]/95 backdrop-blur-xl border-t border-[#232326] p-3">
    <a
      href={FREE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-mobile-cta"
      className="tap-target flex items-center justify-center w-full bg-[#C6FF3D] text-black font-semibold rounded-full py-3.5 hover:scale-[1.01] transition-transform duration-300"
    >
      Get My Free Plan
    </a>
  </div>
);
